module.exports = __webpack_public_path__ + "static/media/raceday-2.28347da6.png";